import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import * as BG from "@/lib/content";
import * as EN from "@/lib/content.en";
import { UI } from "@/lib/ui";

const LangContext = createContext(null);
const KEY = "ra-lang";

const initial = () => {
  const saved = localStorage.getItem(KEY);
  return saved === "en" ? "en" : "bg";
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(initial);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    localStorage.setItem(KEY, l);
    setLangState(l);
  }, []);

  const value = useMemo(() => ({ lang, setLang, t: UI[lang], c: lang === "en" ? EN : BG }), [lang, setLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
